import { constantRouterMap } from '@/config/router.config'
import { getRouters } from '@/api/menu'
import { BasicLayout, RouteView } from '@/layouts'
import { bxAnaalyse } from '@/core/icons'


// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
  return asyncRouterMap.filter(route => {
    if (route.component) {
      // Layout组件特殊处理
      if (route.component === 'RouteView') {
        route.component = RouteView
      } else {
        route.component = loadView(route.component)
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })
}

export const loadView = (view) => { // 路由懒加载
  return () => import(`@/views/${view}`)
}


// 生成首页路由
export function generateIndexRouter(data) {
  let indexRouter = [{
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '首页' },
    redirect: '/dashboard/analysis',
    children: [
      // dashboard
      {
        path: '/dashboard/analysis',
        name: 'Analysis',
        // redirect: '/dashboard/analysis',
        // component: RouteView,
        component: () => import('@/views/dashboard/Analysis'),
        meta: { title: '主页', keepAlive: true, icon: bxAnaalyse},
        // children: [
        //   {
        //     path: '',
        //     name: 'Analysis',
        //     component: () => import('@/views/dashboard/Analysis'),
        //     meta: { title: '分析页', keepAlive: false}
        //   },
        //   // 外部链接
        //   // {
        //   //   path: 'https://www.baidu.com/',
        //   //   name: 'Monitor',
        //   //   meta: { title: '监控页（外部）', target: '_blank' }
        //   // }
        // ]
      },
      {
        path: '/account',
        component: RouteView,
        redirect: '/account/center',
        name: 'account',
        hidden: true,
        meta: { title: '个人页', icon: 'user', keepAlive: true, permission: [ 'user' ] },
        children: [
          {
            path: '/account/center',
            name: 'settings',
            component: () => import('@/views/account/settings/Index'),
            meta: { title: '个人设置', hideHeader: true },
            redirect: '/account/settings/password',
            hideChildrenInMenu: true,
            children: [
              {
                path: '/account/settings/password',
                name: 'PasswordSettings',
                component: () => import('@/views/account/settings/Password'),
                meta: { title: '修改密码', hidden: true }
              },
            ]
          }
        ]
      },
      ...filterAsyncRouter(data)
    ]
  },{
    "path": "*", "redirect": "/404", "hidden": true
  }]
  return indexRouter;
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes ({ commit }) {
      return new Promise(resolve => {
        getRouters().then((res) => {
          if (res.code == 200) {
            //console.log(res)
            // const accessedRoutes = filterAsyncRouter(res.data)
            const accessedRoutes = generateIndexRouter(res.data)
            //console.log(accessedRoutes)
            commit('SET_ROUTERS', accessedRoutes)
            resolve()
          }
        })
       })
    }
  }
}

export default permission
